import SeasonIllustrationBackground from '@/components/SeasonIllustrationBackground/SeasonIllustrationBackground';
import WordMarkLogo from '@/components/WordMarkLogo/WordMarkLogo';
import {
	minimumNativeVersion,
	useCurrentNativeVersion,
	useNativePlatform,
} from '@/hooks/native/useIsNative';

const UnsupportedRoute = () => {
	const currentNativeVersion = useCurrentNativeVersion();
	const nativePlatform = useNativePlatform();

	return (
		<SeasonIllustrationBackground>
			<div className="size-full overflow-y-auto">
				<WordMarkLogo withShadow className="mx-auto my-8" />
				<main className="relative min-h-svh bg-primary p-4 text-white">
					<h1 className="pb-2 text-center font-brand text-4xl">
						<span className="inline-block -rotate-2 text-6xl">
							Update
						</span>{' '}
						naar de nieuwste versie
					</h1>
					<p>
						Leuk dat je meedoet met SoortSafari! Er wacht een
						nieuwere versie op jou die nog beter is. Jouw versie:{' '}
						{currentNativeVersion ?? 'niet gevonden'}. Deze versie
						moet je minimaal hebben: {minimumNativeVersion}.
					</p>

					{nativePlatform === 'android' && <HelpMessageAndroid />}
					{nativePlatform === 'ios' && <HelpMessageIOS />}
				</main>
			</div>
		</SeasonIllustrationBackground>
	);
};

const HelpMessageAndroid = () => (
	<>
		<div className="flex gap-4 pt-4">
			<div className="mt-1 size-12 shrink-0 overflow-hidden rounded-full bg-white p-1.5">
				<img
					className="size-9"
					src="/assets/logos/play-store.jpg"
					alt="Google Play icoon"
				/>
			</div>
			<div className="grow">
				<h2 className="text-2xl">Google Play</h2>
				<p>
					Open de Google Play Store en download via daar de nieuwste
					versie.
				</p>
			</div>
		</div>
	</>
);

const HelpMessageIOS = () => (
	<>
		<div className="flex gap-4 pt-4">
			<img
				className="mt-1 size-12 shrink-0 rounded-xl"
				src="/assets/logos/app-store.jpg"
				alt="App Store icoon"
			/>
			<div className="grow">
				<h2 className="text-2xl">App Store</h2>
				<p>
					Heb je de app gedownload uit de App Store? Gebruik dan de
					App Store om de nieuwe versie te downloaden.
				</p>
			</div>
		</div>
		<div className="flex gap-4 pt-4">
			<img
				className="mt-1 size-12 shrink-0 rounded-xl"
				src="/assets/logos/testflight.jpg"
				alt="App Store icoon"
			/>
			<div className="grow">
				<h2 className="text-2xl">TestFlight</h2>
				<p>
					Heb je de app gedownload via TestFlight? Kijk dan in
					TestFlight of er een nieuwe versie beschikbaar is. Is er
					geen nieuwe versie in TestFlight? Dan kan je de nieuwe
					versie via de App Store installeren.
				</p>
			</div>
		</div>
	</>
);

export default UnsupportedRoute;
